export enum DeliveryTimeSlot {
  MORNING = '09:00 - 13:00',
  AFTERNOON = '14:00 - 18:00',
}

export const DeliveryTimeSlotMap: Record<DeliveryTimeSlot, string> = {
  [DeliveryTimeSlot.MORNING]: '09:00 - 13:00',
  [DeliveryTimeSlot.AFTERNOON]: '14:00 - 18:00',
}
